<template>
    <div>
        <div>
            <md-card class="cardPlayer" id="cardPlayer">
                <md-card-content>
                    <md-list>
                        <md-list-item v-if="loading.seasonPlayers">
                          <span class="md-list-item-text">Loading...</span>
                        </md-list-item>
                        <md-list-item v-for="player in seasonPlayers" :key="player.id">
                            <span class="md-list-item-text md-subheading">{{player.n}}</span>
                            <md-button class="md-icon-button md-accent" @click="showEditPlayer(player.id)">
                                <md-icon>more_horiz</md-icon>
                            </md-button>
                        </md-list-item>
                    </md-list>
                </md-card-content>
                <md-card-actions>
                    <md-button class="md-icon-button md-accent" @click="showAddPlayer()">
                        <md-icon>add_circle</md-icon>
                    </md-button>
                </md-card-actions>
            </md-card>
        </div>
        <md-dialog :md-active.sync="showEditPlayerDialog">
            <md-dialog-title>Edit Player</md-dialog-title>
            <md-dialog-content>
                <form novalidate @submit.prevent="validateEditPlayer()">
                    <md-field :class="getValidationClass('edit','playerName')">
                        <label for="editPlayerName">Name</label>
                        <md-input name="editPlayerName" id="editPlayerName" v-model.trim="edit.playerName"></md-input>
                        <span class="md-error" v-if="!$v.edit.playerName.required">Player name is required</span>
                    </md-field>
                    <md-field :class="getValidationClass('edit', 'playerHandicap')">
                        <label for="editPlayerHandicap">Handicap</label>
                        <md-input name="editPlayerHandicap" id="editPlayerHandicap" v-model.number="edit.playerHandicap" type="number"></md-input>
                        <span class="md-error" v-if="!$v.edit.playerHandicap.required">Player Handicap is required</span>
                        <span class="md-error" v-if="(!$v.edit.playerHandicap.integer || !$v.edit.playerHandicap.minValue)">Player Handicap must be 0 or positive integer</span>
                    </md-field>
                    <md-switch v-model="edit.playerParticipateYearEnd">Particapting in year end</md-switch>
                    <div class="md-dialog-actions">
                        <md-button class="md-accent" @click="showDeletePlayerConfirm = true">Delete</md-button>
                        <md-button class="md-accent" @click="showEditPlayerDialog = false">Close</md-button>
                        <md-button class="md-accent" type="submit">Save</md-button>
                    </div>
                </form>
            </md-dialog-content>
        </md-dialog>
        <md-dialog :md-active.sync="showAddPlayerDialog">
            <md-dialog-title>New Player</md-dialog-title>
            <md-dialog-content>
                <form novalidate @submit.prevent="validateAddPlayer()">
                    <md-field :class="getValidationClass('add','playerName')">
                        <label for="addPlayerName">Name</label>
                        <md-input name="addPlayerName" id="addPlayerName" v-model.trim="add.playerName"></md-input>
                        <span class="md-error" v-if="!$v.add.playerName.required">Player name is required</span>
                    </md-field>
                    <md-field :class="getValidationClass('add', 'playerHandicap')">
                        <label for="addPlayerHandicap">Handicap</label>
                        <md-input name="addPlayerHandicap" id="addPlayerHandicap" v-model.number="add.playerHandicap" type="number"></md-input>
                        <span class="md-error" v-if="!$v.add.playerHandicap.required">Player Handicap is required</span>
                        <span class="md-error" v-if="(!$v.add.playerHandicap.integer || !$v.add.playerHandicap.minValue)">Player Handicap must be 0 or positive integer</span>
                    </md-field>
                    <switch v-model="add.playerParticipateYearEnd">Particapting in year end</switch>
                    <div class="md-dialog-actions">
                        <md-button class="md-accent" @click="showAddPlayerDialog = false">Close</md-button>
                        <md-button type="submit" class="md-accent">Save</md-button>
                    </div>
                </form>
            </md-dialog-content>
        </md-dialog>
        <md-dialog-confirm :md-active.sync="showDeletePlayerConfirm" md-title="Delete Player?"
        :md-content="'Player will be removed from all season games and stats.  Remaining player stats may be altered, due to a possible change to the number of players in completed games.<br>Are you sure you want to delete player ' + edit.playerName + '?'"
        md-confirm-text="Yes" md-cancel-text="No" @md-confirm="deletePlayer()"/>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { required, integer, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'SeasonPlayers',
  data: function () {
    return {
      showEditPlayerDialog: false,
      showAddPlayerDialog: false,
      showDeletePlayerConfirm: false,
      edit: {
        playerName: '',
        playerHandicap: 0,
        playerId: -1,
        playerParticipateYearEnd: true
      },
      add: {
        playerName: '',
        playerHandicap: 0,
        playerParticipateYearEnd: true
      },
      seasonPlayersOnSnapshot: null,
      bypass: false
    }
  },
  validations: {
    add: {
      playerName: {
        required
      },
      playerHandicap: {
        required,
        integer,
        minValue: minValue(0)
      }
    },
    edit: {
      playerName: {
        required
      },
      playerHandicap: {
        required,
        integer,
        minValue: minValue(0)
      }
    }
  },
  computed: {
    ...mapState(['seasonPlayers', 'loading', 'activeSeasonId']),
    ...mapGetters(['playerById'])
  },
  created: function () {
    if (this.activeSeasonId === -1) {
      this.bypass = true
      if (!this.$route.path.toLowerCase().startsWith('/season/settings')) {
        this.$router.push('/season/settings')
      }
    }
  },
  methods: {
    ...mapActions(['displayError', 'displayMessage']),
    getValidationClass (fieldType, fieldName) {
      var field = null
      if (fieldType === 'add') {
        field = this.$v.add[fieldName]
      } else if (fieldType === 'edit') {
        field = this.$v.edit[fieldName]
      }

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearPlayer () {
      this.$v.$reset()
      this.add.playerName = null
      this.add.playerHandicap = 0
      this.edit.playerName = null
      this.edit.playerHandicap = 0
      this.edit.playerParticipateYearEnd = true
      this.edit.playerId = -1
    },
    showEditPlayer: function (playerId) {
      let player = this.playerById(playerId)
      this.edit.playerName = player.n
      this.edit.playerHandicap = player.h
      this.edit.playerParticipateYearEnd = player.y
      this.edit.playerId = playerId
      this.showEditPlayerDialog = true
    },
    deletePlayer: function () {
      let playerId = this.edit.playerId
      let seasonId = this.activeSeasonId
      let playerName = this.edit.playerName
      this.$store.dispatch('deleteSeasonPlayer', {seasonId, playerId}).then(() => {
        this.displayMessage('Player ' + playerName + ' deleted successfully.')
        this.showEditPlayerDialog = false
        this.$store.dispatch('startSnapshot', {'collection': 'seasonStats', 'name': 'seasonStats'})
      }).catch((err) => {
        this.displayError('Error deleting player: ' + err.message)
      })
    },
    updatePlayer: function () {
      let player = {}
      let seasonId = this.activeSeasonId
      player.n = this.edit.playerName
      player.h = this.edit.playerHandicap
      player.y = this.edit.playerParticipateYearEnd
      player.id = this.edit.playerId
      this.$store.dispatch('editSeasonPlayer', {seasonId, player}).then(() => {
        this.displayMessage('Player ' + player.n + ' updated successfully.')
        this.showEditPlayerDialog = false
        this.$store.dispatch('startSnapshot', {'collection': 'seasonStats', 'name': 'seasonStats'})
      }).catch((err) => {
        this.displayError('Error updating player: ' + err.message)
      })
    },
    showAddPlayer: function () {
      this.clearPlayer()
      this.showAddPlayerDialog = true
    },
    validateAddPlayer () {
      this.$v.$touch()

      if (!this.$v.add.$invalid) {
        this.addPlayer()
      }
    },
    validateEditPlayer () {
      this.$v.$touch()

      if (!this.$v.edit.$invalid) {
        this.updatePlayer()
      }
    },
    addPlayer: function () {
      let player = {}
      let seasonId = this.activeSeasonId
      player.n = this.add.playerName
      player.h = this.add.playerHandicap
      player.y = this.add.playerParticipateYearEnd
      this.$store.dispatch('addSeasonPlayer', {seasonId, player}).then(() => {
        this.displayMessage('Player ' + player.n + ' added successfully.')
        this.showAddPlayerDialog = false
        this.$store.dispatch('startSnapshot', {'collection': 'seasonStats', 'name': 'seasonStats'})
      }).catch((err) => {
        this.displayError('Error adding player: ' + err.message)
      })
    }
  }
}
</script>

<style lang="scss">
  .cardPlayer{
      width: 250px;
  }
  .md-card-content {
      padding: 5px;
  }
  .md-button {
      margin: 6px 4px;
  }
  .md-icon-button {
      margin: 0 6px;
  }
</style>
<style lang="scss" scoped>

</style>
